import getCombatantLastRoundAction from './getCombatantLastRoundAction'
import getCombatantPreviousRoundActionImage from './getCombatantPreviousRoundActionImage'

export default async function getViewedRoundLastActionImage({
  combatant,
  viewRound,
  arenaRound,
  maxCA,
  extraActionSlot,
}) {
  if (!Number.isFinite(viewRound) || viewRound <= 1) {
    return ''
  }

  if (Number.isFinite(arenaRound) && viewRound === arenaRound + 1) {
    const lastAction = getCombatantLastRoundAction(combatant, maxCA, arenaRound)
    return lastAction?.image || ''
  }

  return await getCombatantPreviousRoundActionImage(combatant, viewRound, extraActionSlot)
}
